export default __webpack_public_path__ + "static/media/ic_red_trangle.e712fa23.svg";